import { Component } from '@angular/core';
import {  Router } from '@angular/router';
import { LoaderService } from './services/loader.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'liveshow';
  constructor(private router: Router,public loaderService: LoaderService) {}
  
}
